module.exports = __webpack_public_path__ + "static/media/logo7.e351578f.png";